import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { FaSpinner } from 'react-icons/fa';

import { loadProductsDiscounted } from '../../../redux/modules/products';
import connectDataFetchers from '../../shared/lib/connectDataFetchers.js';

import LeftFilters from '../../shared/LeftFilters/LeftFilters';
import Breadcrumb from '../../shared/Breadcrumb/Breadcrumb';
import Pager from '../../shared/Pager/Pager';
import ProductThumbnail from '../../shared/ProductThumbnail/ProductThumbnail';
import A from '../../shared/Anchor/Anchor';

import { primary_dark15, primary_light } from '../../shared/lib/colors';

import '../Categoria/Categoria.scss';
import { ga4ViewItemList } from '../../shared/lib/ga4EnhancedEcommerce';
import { fkmxViewItemList } from '../../shared/lib/farmakomMetrics';
import { gtmToGa4ViewItemList } from '../../shared/lib/gtmEnhancedEcommerce.js';
import { cleanImage } from '../../../utils/images.js';

class InOfferta extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showFilters: false,
    };
  }

  componentDidMount() {
    // TRACK LIST - GTM, GA4, FKMX
    if (
      [
        this.props.hasGoogleTagManager,
        this.props.hasGoogleAnalytics4Advanced,
        this.props.hasFarmakomMetrics,
      ].some(t => !!t)
    ) {
      this.trackItemsList();
    }
  }

  componentDidUpdate(oldProps) {
    if (this.props.loading !== oldProps.loading && !this.props.loading) {
      // TRACK LIST - GTM, GA4, FKMX
      if (
        [
          this.props.hasGoogleTagManager,
          this.props.hasGoogleAnalytics4Advanced,
          this.props.hasFarmakomMetrics,
        ].some(t => !!t)
      ) {
        this.trackItemsList();
      }
    }
  }

  trackItemsList = () => {
    const { products } = this.props;

    const ga4ListInfo = {
      id: `prodotti_in-offerta`,
      name: `prodotti > in-offerta`,
    };

    if (this.props.hasGoogleTagManager) {
      gtmToGa4ViewItemList(products, ga4ListInfo);
    }
    if (this.props.hasGoogleAnalytics4Advanced) {
      ga4ViewItemList(products, ga4ListInfo);
    }
    if (this.props.hasFarmakomMetrics) {
      fkmxViewItemList(products, ga4ListInfo);
    }
  };

  toggleFilters = event => {
    event.preventDefault();
    this.setState({
      showFilters: !this.state.showFilters,
    });
  };

  renderProducts() {
    const { isMobile } = this.props;
    return (
      <div style={{ width: '100%' }}>
        {!isMobile && (
          <div className={'desktop'}>{this.renderProductsDesktop()}</div>
        )}
        {isMobile && (
          <div className={'mobile'}>{this.renderProductsMobile()}</div>
        )}
      </div>
    );
  }

  renderProductsDesktop = () => {
    const ga4ListInfo = {
      id: `prodotti_in-offerta`,
      name: `prodotti > in-offerta`,
    };
    return (
      <div className={'desktop-container'}>
        {this.props.products.map(product => {
          return (
            <div className="col-sm-6 col-lg-4" key={product.id}>
              <ProductThumbnail
                product={product}
                list="In offerta"
                ga4ListInfo={ga4ListInfo}
              />
            </div>
          );
        })}
      </div>
    );
  };

  renderProductsMobile = () => {
    const ga4ListInfo = {
      id: `prodotti_in-offerta`,
      name: `prodotti > in-offerta`,
    };
    return (
      <div>
        <div className={'mobile-container'}>
          {this.props.products.map((product, index) => {
            return (
              <div style={{ width: '48%' }}>
                <ProductThumbnail
                  key={product.id}
                  product={product}
                  list="In offerta"
                  spaceStar={6}
                  ga4ListInfo={ga4ListInfo}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  render() {
    const { showFilters } = this.state;
    const {
      location,
      pagination,
      products,
      loading,
      siteName,
      logoImage,
      primaryColor,
      uiVariantButton,
    } = this.props;

    return (
      <div className={`categoria ${showFilters ? 'filters-open' : ''}`}>
        <Helmet
          title={`Prodotti e Farmaci in offerta`}
          meta={[
            {
              name: 'description',
              content: `${siteName} - Ecommerce Farmacia vendita farmaci in offerta`,
            },
            { name: 'keywords', content: `${siteName}, ecommerce, farmacia` },
            {
              property: 'og:title',
              content: `${siteName} - Ecommerce Farmacia vendita farmaci in offerta`,
            },
            { property: 'og:type', content: 'website' },
            {
              property: 'og:description',
              content: `${siteName} - Ecommerce Farmacia vendita farmaci in offerta`,
            },
            { property: 'og:image', content: cleanImage(logoImage) },
          ]}
        />

        <div className="container">
          <LeftFilters
            location={location}
            sort={location.query.sort || 'sales'}
          />

          <div className="elenco-prodotti">
            <div className="pre-title">
              <A
                href="#"
                className="filter-toggle"
                onClick={this.toggleFilters}
              >
                {showFilters ? 'Nascondi filtri' : 'Mostra filtri'}
              </A>

              <Breadcrumb page="prodotti" discounted={true} />

              {products.length > 0 && (
                <Pager
                  location={location}
                  page={location.query.page || 1}
                  totalPages={pagination.totalPages}
                  sort={location.query.sort || 'sales'}
                  primaryColor={primaryColor}
                  uiVariantButton={uiVariantButton}
                />
              )}
            </div>

            <div
              className="page-title"
              style={{
                color: primary_dark15(primaryColor),
                backgroundColor: primary_light(primaryColor),
              }}
            >
              Prodotti in offerta
              {loading && (
                <span className="pull-right">
                  <FaSpinner className="pulse" />
                </span>
              )}
            </div>
            {!loading && products.length > 0 && (
              <div>
                <div className="row">{this.renderProducts()}</div>

                <Pager
                  location={location}
                  page={location.query.page || 1}
                  totalPages={pagination.totalPages}
                  primaryColor={primaryColor}
                  isNew
                  uiVariantButton={uiVariantButton}
                />
              </div>
            )}

            {!loading && products.length === 0 && (
              <div className="no-results">
                <p>Nessun prodotto in offerta in questo momento</p>
                <p>Torna a trovarci presto!</p>
              </div>
            )}
          </div>
          <div className="clearfix" />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    isMobile: state.layout.isMobile,
    pagination: state.products.pagination,
    products: state.products.data,
    loading: state.products.loading,
    siteName: state.store.data.datiFarmacia.siteName,
    logoImage: state.store.data.loghiTemplate.logoImage,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    uiVariantButton: state.store.data.uiVariants.buttons,
    hasGoogleAnalytics4Advanced: !!state.store.data.features
      .hasGoogleAnalytics4Advanced,
    hasGoogleTagManager: !!state.store.data.features.hasGoogleTagManager,
    hasFarmakomMetrics: !!state.store.data.integrazioni.metrics.apiKey,
  };
}

export default connect(mapStateToProps)(
  connectDataFetchers(InOfferta, [loadProductsDiscounted])
);
